"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const RightsholderMaintenanceContactTabHeader = () => (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("p", null, " Information entered on the Mailing and Contact tab is used for Member identification. ")));
exports.default = RightsholderMaintenanceContactTabHeader;
